// src/components/EmailVerified.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Check, Home, LogIn } from 'lucide-react';
import styles from './EmailVerified.module.css';

const EmailVerified = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [countdown, setCountdown] = useState(10);
  const [email, setEmail] = useState('');
  
  // Extract email from URL params if available
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailParam = params.get('email');
    if (emailParam) {
      setEmail(emailParam);
    }
  }, [location]);

  // Auto-redirect countdown
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      // Redirect to login when countdown reaches 0
      navigate('/login');
    }
  }, [countdown, navigate]);

  // Handle navigation buttons
  const goToLogin = () => {
    navigate('/login');
  };

  const goToHome = () => {
    navigate('/');
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.iconWrapper}>
          <Check className={styles.checkIcon} />
        </div>
        
        <h1 className={styles.title}>Email Verified!</h1>
        
        <div className={styles.messageContent}>
          <p className={styles.message}>
            Your email address{email ? ` (${email})` : ''} has been successfully verified.
          </p>
          <p className={styles.message}>
            Your account is now active and you can enjoy all the features of Linkist.
          </p>
          <p className={styles.countdown}>
            You will be redirected to the login page in {countdown} {countdown === 1 ? 'second' : 'seconds'}...
          </p>
        </div>
        
        <div className={styles.buttonContainer}>
          <button 
            className={`${styles.button} ${styles.loginButton}`}
            onClick={goToLogin}
          >
            <LogIn size={18} />
            <span>Log In Now</span>
          </button>
          
          <button 
            className={`${styles.button} ${styles.homeButton}`}
            onClick={goToHome}
          >
            <Home size={18} />
            <span>Go to Homepage</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailVerified;